import axios from 'axios'
// import { store } from '@/store/store'
import router from '@/router'

class HttpRequest {
  constructor (baseUrl = baseURL) {
    this.baseUrl = baseUrl
    this.queue = {}
  }
  getInsideConfig () {
    const config = {
      baseURL: this.baseUrl,
      headers: {
        //
      }
    }
    return config
  }
  destroy (url) {
    delete this.queue[url]
    if (!Object.keys(this.queue).length) {
      // Spin.hide()
    }
  }
  interceptors (instance, url) {
    // 请求拦截
    // instance.interceptors.request.use(config => {
    //   // 添加全局的loading...
    //   if (!Object.keys(this.queue).length) {
    //   }
    //   this.queue[url] = true
    //   // 让每个请求携带自定义token 
    //   config.headers['Authorization'] ='Bearer ' +  store.getters.token,
    //   // 平台：浏览器
    //   config.headers['Platform'] ='BROWSER' 
    //   return config
    // }, error => {
    //   return Promise.reject(error)
    // })
    // // 响应拦截
    // instance.interceptors.response.use(res => {
    //   this.destroy(url)
    //   const { data, status } = res
    //   if(data.code == 403){
    //     router.push({ name: 'Page403'});
    //   }
    //   return { data, status }
    // }, error => {
    //   this.destroy(url)
    //   let errorInfo = error.response
    //   if (!errorInfo) {
    //     const { request: { statusText, status }, config } = JSON.parse(JSON.stringify(error))
    //     errorInfo = {
    //       statusText,
    //       status,
    //       request: { responseURL: config.url }
    //     }
    //   }
    //   return Promise.reject(error)
    // })
  }
  request (options) {
    const instance = axios.create()
    options = Object.assign(this.getInsideConfig(), options)
    this.interceptors(instance, options.url)
    return instance(options)
  }
}
export default HttpRequest



// WEBPACK FOOTER //
// ./src/config/axios.js